<template>
  <div>
    <v-autocomplete
      :value="language"
      :items="filterLanguages"
      :label="label"
      @change="changedTo"
      :multiple="multiple"
      ref="select"
      :loading="loading"
      :clearable="clearable"
      @click:clear="clear"
      :search-input.sync="filter"
      autocomplete="nope"
      :no-filter="true"
    >
      <template v-slot:selection="data">
        <div v-if="multiple === false">
          <div ripple class="height32">
            <v-img :src="data.item.pic" class="flag-img"></v-img>
            <h5 v-if="hideName == null" class="text-title">
              {{ data.item.code + " - " + data.item.name }}
            </h5>
          </div>
        </div>
        <div v-else>
          <v-img :src="data.item.pic" class="flag-img"></v-img>
          <div
            v-if="hideName == null"
            class="v-chip--select v-chip v-chip--clickable v-chip--no-color theme--light v-size--default"
          >
            {{ data.item.code + " - " + data.item.name }}
            <v-icon
              style="float: right; margin-left: 5px"
              small
              @click="remove(data.item)"
              >mdi-close</v-icon
            >
          </div>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title>
              <v-img
                :src="data.item.pic"
                height="20"
                width="24"
                style="float: left; margin-right: 10px"
              ></v-img>
              <div>{{ data.item.code + " - " + data.item.name }}</div>
              <v-icon small v-if="selected(data.item)" style="float: right"
                >mdi-check</v-icon
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import common from "@/store/common/module/common";
import { commonMixin } from "@/mixins/common";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "LanguageSelect",
  props: {
    value: {
      default: false,
    },
    hideName: {
      default: null,
    },
    multiple: {
      default: false,
    },
    label: {
      default: "Language",
    },
    clearable: {
      default: false,
    },
    rules: {
      default: () => [],
    },
  },
  mixins: [Themeable, commonMixin],
})
export default class LanguageSelect extends (Vue, Themeable) {
  language = null;
  languages = [];
  loading = true;
  filter = "";

  clear() {
    this.filter = "";
    this.language = null;
    this.$emit("input", null);
  }

  get filterLanguages() {
    if (this.languages == null || this.languages.length == 0) {
      return [];
    }
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    if (filterby == "") return this.languages;
    const fc = this.languages.filter(function (c) {
      return c.name.toLowerCase().indexOf(filterby) >= 0;
    });
    return fc;
  }

  changedTo(newVal) {
    this.filter = "";
    if (this.multiple === false || this.multiple != "") {
      if (newVal) {
        this.language = newVal;
        if (newVal && newVal.code) {
          this.$emit("input", newVal.code);
        }
      } else {
        this.$emit("input", null);
      }
    } else {
      const response = [];

      for (let i = 0; i < newVal.length; i++) {
        response.push(newVal[i].code);
      }

      this.$emit("input", response);
    }
  }

  setDefault() {
    // if (this.value) {
    //   for (let i = 0; i < this.languages.length; i++) {
    //     if (this.languages[i].name === this.value) {
    //       this.languages = this.languages[i];
    //       break;
    //     }
    //   }
    // }

    if (
      (this.value &&
        this.languages != null &&
        this.languages.length > 0 &&
        this.multiple != "") ||
      this.multiple === false
    ) {
      if (this.languages) {
        for (let i = 0; i < this.languages.length; i++) {
          if (this.languages[i].code === this.value) {
            this.language = this.languages[i];
            break;
          }
        }
      }
    } else if (this.languages != null && this.languages.length > 0) {
      this.language = [];
      if (this.value != null && this.value != "" && this.languages.length > 0) {
        for (let i = 0; i < this.languages.length; i++) {
          if (this.value === this.languages[i].code) {
            this.language.push(this.languages[i]);
          }
        }
      }
    }
    this.loading = false;
  }

  async mounted() {
    await common.populateLanguages();
    this.languages = common.languages;
    this.setDefault();
    this.loading = false;
  }

  @Watch("value")
  async onValueChange() {
    if (this.value == "" || this.value == null) {
      this.language = null;
    }
    await common.populateLanguages();
    this.languages = common.languages;
    this.setDefault();
  }

  selected(val) {
    if (val != null && val.code != null && this.language != null) {
      if (Array.isArray(this.language)) {
        for (let i = 0; i < this.language.length; i++) {
          if (val.code === this.language[i].code) {
            return true;
          }
        }
      } else if (this.language != null && this.language.code != undefined) {
        if (val.code === this.language.code) {
          return true;
        }
      }
    }
    return false;
  }

  remove(val) {
    if (val != null && val.code != null && this.language != null) {
      if (Array.isArray(this.language)) {
        for (let i = 0; i < this.language.length; i++) {
          if (val.code === this.language[i].code) {
            this.language.splice(i, 1);
            const response = [];
            for (let i = 0; i < this.language.length; i++) {
              response.push(this.language[i].code);
            }
            this.$emit("input", response);
            break;
          }
        }
      }
    }
    return false;
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 60px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.flag-img {
  float: left;
  margin-right: 10px;
  height: 20px;
  width: 24px;
  margin: 5px 10px 2px 0;
}
</style>
